import { Component, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { ApiService } from 'src/app/services/api-services/api.service';
import { LanguageService } from 'src/app/services/languageservice/language.service';

@Component({
  selector: 'app-language-switch',
  templateUrl: './language-switch.component.html',
  styleUrls: ['./language-switch.component.scss'],
})
export class LanguageSwitchComponent implements OnInit {


  languages: any[] = []
  constructor(public languageService: LanguageService,
    private platform: Platform,
    private apiService: ApiService
    ) { 

  }

  ngOnInit() {
    this.languages = this.languageService.getLanguage()
  }

  compare(e1: any, e2: any): boolean {
    return e1 && e2 ? e1.value == e2.value : e1 == e2;
  }

  changeLanguage(event) {
    this.languageService.selectLanguage(event.target.value)
    let languageToSendToApi = event.target.value.value;
    languageToSendToApi == 'en-GB' ? languageToSendToApi = 'en' : languageToSendToApi = languageToSendToApi;
    this.apiService.chnageUserLanguage(languageToSendToApi).subscribe ((response) => {
      if (response == true) {
        localStorage.setItem("selectedlanguage",JSON.stringify( event.target.value));
      }
    })
    
  }
}
